<template>
  <button
    v-if="!museum"
    @click.stop="setPlace"
    class="textbutton linkcolor"
    type="button"
  >
    <StopComponent :place="place" />
  </button>
</template>

<script>
import { mapState } from 'vuex'

import StopComponent from '@/components/Stop.vue'

export default {
  name: 'StopAction',
  components: {
    StopComponent
  },
  props: ['place'],
  computed: mapState({
    museum: (state) => state.museum,
    storePlace: (state) => state.place
  }),
  methods: {
    setPlace() {
      if (this.place?.id !== this.storePlace?.id) {
        this.$store.dispatch('selectPlace', this.place?.id)
      } else if (this.$route.name !== 'place' && !this.museum) {
        this.$router.push({
          name: 'place',
          params: {
            id: this.place?.id
          }
        })
      }
    }
  }
}
</script>
